export default __webpack_public_path__ + "static/media/b.1c69e963.jpg";